<template>
  <div class="box16">
    <pageTitle
      title="好品牌&nbsp;&nbsp;源自好口碑"
      text="课程是否优秀、实力是否雄厚，学生真实评价才是有效验证"
    />
    <studentEvaluation
      :evaluateData="evaluateData"
      :styleData="styleData"
      @provideIndex="provideIndex"
      scrollColor="#c9c7ff"
      blockColor="#5d5bf5"
    />
    <previewImage
      ref="previewImage"
      :clickedIndex="clickedIndex"
      :isPreview="isPreview"
      type="img"
      :targetImg="evaluateData[this.cur].imgUrlList[this.clickedIndex].img"
      @close="close"
    />
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import previewImage from "../common/previewImage.vue";
import studentEvaluation from "../common/student-evaluation.vue";
export default {
  components: {
    pageTitle,
    studentEvaluation,
    previewImage,
  },

  data() {
    return {
      clickedIndex: 0,
      isPreview: false,
      cur: 0,
      evaluateData: [
        {
          imgUrlList: [
            {
              img: require("../../../assets/coursePage/ai/box16/1.png"),
              id: 1,
            },
            {
              img: require("../../../assets/coursePage/ai/box16/2.png"),
              id: 2,
            },
          ],
        },
        {
          imgUrlList: [
            {
              img: require("../../../assets/coursePage/ai/box16/3.png"),
              id: 3,
            },
            {
              img: require("../../../assets/coursePage/ai/box16/4.png"),
              id: 4,
            },
          ],
        },
        {
          imgUrlList: [
            {
              img: require("../../../assets/coursePage/ai/box16/5.png"),
              id: 5,
            },
            {
              img: require("../../../assets/coursePage/ai/box16/6.png"),
              id: 6,
            },
          ],
        },
      ],

      titleColor: "#3E4F48",

      styleData: {
        imgBorder: "border: 0.053333rem solid rgb(180, 228, 255);",
        imgHoverBorder: "border: 0.053333rem solid rgb(46, 165, 252);;",
      },
    };
  },
  methods: {
    provideIndex(index, index1) {
      this.clickedIndex = index1;
      this.cur = index;
      this.isPreview = true;
    },
    close() {
      this.isPreview = false;
      this.clickedIndex = 0;
      this.cur = 0;
      // this.imageUrl = "";
    },
  },
};
</script>

<style lang="scss" scoped>
.box16 {
  padding: 80px 0 88px;
  width: 100%;
  background: #ffffff;
}
</style>
